const Documents = ({ children }) => {
    return (
        <div className="main-content__documents-card-view">
            {children}
        </div>
    );
};

export default Documents;
